export default {
    ESP: 'Español',
    ENG: 'Inglés'
};
